import { DOCUMENT } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { AppConfig } from '../assets/config/appconfig';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'CCA IFrame';

  constructor(@Inject(DOCUMENT) private document: Document, private appConfig: AppConfig) {
    this.loadTheme(`${appConfig.settings.ccaName.toLowerCase()}-styles.css`);
  }

  loadTheme(styleFile: string) {
    const head = this.document.getElementsByTagName('head')[0];
    const newLinkEl = this.document.createElement('link');
    newLinkEl.rel='stylesheet';
    newLinkEl.href=styleFile;
    head.appendChild(newLinkEl);
  }
}
